module.exports = __webpack_public_path__ + "static/img/icon-CBR.7604a11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-CBR.svg
// module id = Bm7G
// module chunks = 0